// api/payments.js
import apiClient from './client';

export const paymentApi = {
  // Get all payments
  getAll: () => apiClient.get('/payments'),
  
  // Get payment by ID
  getById: (id) => apiClient.get(`/payments/${id}`),
  
  // Create payment
  create: (data) => apiClient.post('/payments', data),
  
  // Update payment
  update: (id, data) => apiClient.put(`/payments/${id}`, data),
  
  // Delete payment
  delete: (id) => apiClient.delete(`/payments/${id}`),
  
  // Get payments by customer
  getByCustomer: (customerId) => apiClient.get(`/payments/customer/${customerId}`),
};